export enum BuildingTypeEnum {
    COMMERCIAL = 'COMMERCIAL',
    MOBILE = 'MOBILE',
    RESIDENTIAL = 'RESIDENTIAL',
    ROOM = 'ROOM',
    SHOPPING = 'SHOPPING'
  }